export default __webpack_public_path__ + "e25622c3ee540a9a427ae6b3bb0ec00f.fig";